import type { BackendAxiosError } from "services/api/backendError";
import { getBackendErrorMessage } from "services/api/backendError";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

const MESSAGE_TO_ALERT_KEY: Record<string, string> = {
  "Employee number is already in use":
    "Staff.ProfilePanelErrorEmployeeNumberAlreadyInUse",
  "Selected start date is not allowed": "Staff.ProfilePanelErrorDateNotAllowed",
  "Worker not found": "Staff.ProfilePanelErrorWorkerNotFound",
  "Worker can not be edited": "Staff.ProfilePanelErrorWorkerCanNotBeEdited",
  "Employment overlaps with existing employment":
    "Staff.ProfilePanelErrorEmploymentOverlapsWithExistingEmployment",
  "Can not set date to before existing start date":
    "Staff.ProfilePanelErrorCanNotSetDateBeforeExistingStartDate",
  "Need to include one salary": "Staff.ProfilePanelErrorNeedToIncludeOneSalary",
  "Employment not found": "Staff.ProfilePanelErrorEmploymentNotFound",
  "Salary already exists": "Staff.ProfilePanelSalaryAlreadyExists",
  "Can not set date to before employment start date":
    "Staff.ProfilePanelErrorCanNotSetDateBeforeEmploymentStartDate",
  "Tax already exists": "Staff.ProfilePanelErrorTaxAlreadyExists",
  "Need to have at least one employment":
    "Staff.ProfilePanelErrorNeedToHaveAtLeastOneEmployment",
  "Can not delete the first employment":
    "Staff.ProfilePanelErrorCanNotDeleteTheFirstEmployment",
  "Need to have at least one salary":
    "Staff.ProfilePanelErrorNeedToHaveAtLeastOneSalary",
  "Salary not found": "Staff.ProfilePanelErrorSalaryNotFound",
  "Can not delete the first salary":
    "Staff.ProfilePanelErrorCanNotDeleteTheFirstSalary",
  "Need to have at least one tax":
    "Staff.ProfilePanelErrorNeedToHaveAtLeastOneTax",
  "Tax not found": "Staff.ProfilePanelErrorTaxNotFound",
  "Can not delete the first tax":
    "Staff.ProfilePanelErrorCanNotDeleteTheFirstTax",
};

const DELETE_WORKER_MESSAGE_TO_ALERT_KEY: Record<string, string> = {
  "Worker not found": "Staff.ProfilePanelDeleteErrorWorkerNotFound",
  "Can not delete worker with time reports":
    "Staff.ProfilePanelDeleteErrorHasTimeReports",
  "Can not delete registered worker":
    "Staff.ProfilePanelDeleteErrorRegisteredWorker",
  "Worker can not be edited": "Staff.ProfilePanelErrorWorkerCanNotBeEdited",
};

/**
 * Handles resolve staff profile panel error key.
 */
export const resolveStaffProfilePanelErrorKey = (
  error: BackendAxiosError,
): string => {
  const backendMessage = getBackendErrorMessage(error);
  if (!backendMessage) return "Alerts.SomethingWentWrong";
  const mappedKey = MESSAGE_TO_ALERT_KEY[backendMessage];
  if (mappedKey) return mappedKey;
  return "Alerts.SomethingWentWrong";
};

/**
 * Handles resolve delete worker error key.
 */
export const resolveDeleteWorkerErrorKey = (
  error: BackendAxiosError | null | undefined,
): string => {
  const backendMessage = getBackendErrorMessage(error);
  if (!backendMessage) return "Alerts.SomethingWentWrong";
  const mappedKey = DELETE_WORKER_MESSAGE_TO_ALERT_KEY[backendMessage];
  if (mappedKey) return mappedKey;
  return "Alerts.SomethingWentWrong";
};

/**
 * Handles resolve staff profile panel error message.
 */
export const resolveStaffProfilePanelErrorMessage = (
  error: BackendAxiosError,
  translate: TranslateFn,
): string => {
  return translate(resolveStaffProfilePanelErrorKey(error));
};
